import { action, makeObservable, observable } from 'mobx';

class WinBarStore {
  wins = [];

  winAmount = 0;

  isLastSpinWin = false;

  maxWin = false;

  winMatrix = [];

  winLines = null;

  jackpotInfo = {};

  spinResultOdd = 0;

  jackpotAmounts = {};

  jackpotWinInfo = {};

  isScatterWin = false;

  expandingWildData = [];

  winBarSymbolsById = [];

  jackpotSceneResult = {};

  jackpotSceneItemResult = {};

  isLastWinAmountTextVisible = false;

  prevWinAmount = 0;

  constructor() {
    makeObservable(this, {
      maxWin: observable,
      winLines: observable,
      winAmount: observable,
      wins: observable.deep,
      isScatterWin: observable,
      spinResultOdd: observable,
      prevWinAmount: observable,
      isLastSpinWin: observable,
      winMatrix: observable.deep,
      jackpotInfo: observable.deep,
      jackpotWinInfo: observable.deep,
      jackpotAmounts: observable.deep,
      expandingWildData: observable.deep,
      winBarSymbolsById: observable.deep,
      jackpotSceneResult: observable.deep,
      jackpotSceneItemResult: observable.deep,
      isLastWinAmountTextVisible: observable.deep,
      setWins: action.bound,
      setMaxWin: action.bound,
      resetStore: action.bound,
      setWinMatrix: action.bound,
      setWinAmount: action.bound,
      setWinLineNum: action.bound,
      setJackpotInfo: action.bound,
      setIsScatterWin: action.bound,
      setIsLastSpinWin: action.bound,
      setSpinResultOdd: action.bound,
      setPrevWinAmount: action.bound,
      setJackpotAmounts: action.bound,
      setWinBarSymbolsById: action.bound,
      setExpandingWildData: action.bound,
      setJackpotSceneResult: action.bound,
      setJackpotSceneItemResult: action.bound,
      setIsLastWinAmountTextVisible: action.bound,
    });
  }

  setIsLastSpinWin(bool) {
    this.isLastSpinWin = bool;
  }

  setPrevWinAmount(amount) {
    this.prevWinAmount = amount;
  }

  setJackpotInfo(value) {
    const jackPotInfo = value.reduce((acc, current) => {
      acc[current.jackpotCard] = current;
      return acc;
    }, {});
    this.jackpotInfo = jackPotInfo;
  }

  setJackpotWinInfo(value) {
    this.jackpotWinInfo = value;
  }

  setWins(winData) {
    this.wins = [...winData];
  }

  setWinLineNum(lineNumber) {
    this.winLines = lineNumber;
  }

  setSpinResultOdd(odd) {
    this.spinResultOdd = odd;
  }

  setJackpotAmounts(arr) {
    this.jackpotAmounts = arr;
  }

  setJackpotSceneResult(data) {
    this.jackpotSceneResult = data;
  }

  setJackpotSceneItemResult(data) {
    this.jackpotSceneItemResult = data;
  }

  setMaxWin(boolValue) {
    this.maxWin = boolValue;
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setWinMatrix(matrix) {
    this.winMatrix = matrix;
  }

  setIsScatterWin(boolValue) {
    this.isScatterWin = boolValue;
  }

  setWinBarSymbolsById(texturesArr) {
    this.winBarSymbolsById = texturesArr;
  }

  setExpandingWildData(data) {
    this.expandingWildData = data;
  }

  setIsLastWinAmountTextVisible(boolValue) {
    this.isLastWinAmountTextVisible = boolValue;
  }

  resetStore() {
    this.wins = [];

    this.winAmount = 0;

    this.isLastSpinWin = false;

    this.maxWin = false;

    this.winMatrix = [];

    this.winLines = null;

    this.prevWinAmount = 0;
  }
}

export const winBarStore = new WinBarStore();
